// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ActionsPopoverCallback from '../../state/actions-popover-callback';
import ActionsPopoverLink from '../../state/actions-popover-link';
import ActionsPopoverListCallback from './actions-popover-list-callback';
import ActionsPopoverListLink from './actions-popover-list-link';

const getPopoverList = options =>

    options.map((item, index) => {

        let listItem;

        if (ActionsPopoverLink.is(item)) {

            listItem = (
                <ActionsPopoverListLink
                    key={index}
                    label={item.label}
                    route={item.route}
                />
            );

        } else if (ActionsPopoverCallback.is(item)) {

            listItem = (
                <ActionsPopoverListCallback
                    key={index}
                    label={item.label}
                    onOptionClick={item.onOptionClick}
                    onOptionClickValues={item.onOptionClickValues}
                />
            );

        }

        return listItem;

    });

const ActionsPopover = props => (
    <ul className='actions-popover-list'>
        {getPopoverList(props.options)}
    </ul>
);

ActionsPopover.displayName = 'ActionsPopover';
ActionsPopover.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ActionsPopover;



// WEBPACK FOOTER //
// ./src/shared/components/actions-popover/actions-popover-list.js